(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-inquiry"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const drawer = document.getElementById('product-inquiry-drawer');
    if (!drawer) return;

    drawer.addEventListener('on:product-inquiry:after-open', () => {
      const wrapper = document.getElementById('AY3ZkbEt1bTBDZFc2e__forms_inline_XqimaD');
      if (!wrapper) return;

      const tryPrefill = (form) => {
        const root = form.shadowRoot;
        if (!root) return false;

        const productUrl = root.querySelector('[id="custom#product_url"]');
        const productTitle = root.querySelector('[id="custom#product_title"]');
        const fName = root.querySelector('#first_name');
        const email = root.querySelector('#email');
        const phone = root.querySelector('#phone_number');

        if (!productUrl || !productTitle || !fName || !email || !phone) {
          return false;
        }

        productUrl.value = wrapper.dataset.formUrl || '';
        productTitle.value = wrapper.dataset.formTitle || '';
        fName.value = wrapper.dataset.formFname || '';
        email.value = wrapper.dataset.formEmail || '';
        phone.value = wrapper.dataset.formPhone || '';

        [productUrl, productTitle, fName, email, phone].forEach((input) => {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        productUrl.closest('div')?.style.setProperty('display', 'none');
        productTitle.closest('div')?.style.setProperty('display', 'none');

        return true;
      };

      // 1️⃣ If form already exists, fill immediately
      const existingForm = wrapper.querySelector('#app-embed');
      if (existingForm && tryPrefill(existingForm)) return;

      // 2️⃣ Otherwise observe for insertion
      const observer = new MutationObserver((mutations, obs) => {
        const form = wrapper.querySelector('#app-embed');
        if (form && tryPrefill(form)) {
          obs.disconnect();
        }
      });

      observer.observe(wrapper, { childList: true, subtree: true });

      // 3️⃣ Safety timeout
      setTimeout(() => observer.disconnect(), 8000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["judgeme-product-reviews"] && !Shopify.designMode) return;
  try {
    
  const judgemeContainer = document.getElementById("judgeme_product_reviews");
  const title = judgemeContainer.querySelector(".jdgm-rev-widg__title");
  title.style.display = "none";

  } catch(e) { console.error(e); }
})();
})();
